module.exports = __webpack_public_path__ + "static/media/close.3d7174a0.svg";